/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

export const useTemplateForm = (setCrid, crid) => {
  useEffect(() => {
    setCrid(crid)
  }, [])
}
